import { Languages } from "lucide-react";
import { api } from "@/lib/api";
import { getLang, setLang } from "@/i18n/translator";

export function LangToggle({ saveToAccount = false, className = "" }) {
  const cur = getLang();
  const pick = async (l) => {
    if (saveToAccount) { await api.put("/auth/language", { language: l }).catch(() => {}); }
    setLang(l);
  };
  return (
    <div className={`inline-flex items-center gap-1 rounded-full border border-slate-200 bg-white p-0.5 text-xs font-semibold ${className}`} data-testid="lang-toggle" data-no-translate>
      <Languages className="ml-1.5 h-3.5 w-3.5 text-slate-400" />
      {[["es", "ES"], ["en", "EN"]].map(([l, t]) => (
        <button key={l} type="button" onClick={() => pick(l)} data-testid={`lang-${l}`} aria-pressed={cur === l}
          className={`rounded-full px-2.5 py-1 transition-colors ${cur === l ? "bg-blue-600 text-white" : "text-slate-500 hover:bg-slate-100"}`}>{t}</button>
      ))}
    </div>
  );
}
